<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <!-- <a-col :md="6" :sm="24" v-if="userType==0 &&!tenantFirmId">
              <a-form-item label="企业品牌">
                <a-select
                  show-search
                  v-model="queryParam.upperId"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option v-for="d in userList" :key="d.id">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
            <a-col :md="6" :sm="24">
              <a-form-item label="订单号">
                <a-input v-model="queryParam.orderNo" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="师傅名称	">
                <a-input v-model="queryParam.masterName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="师傅电话	">
                <a-input v-model="queryParam.masterPhone" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="客户电话	">
                <a-input v-model="queryParam.receiverMobile" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="客户姓名	">
                <a-input v-model="queryParam.receiverName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单状态">
                <a-select
                  show-search
                  v-model="queryParam.status"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="item.id" v-for="(item, index) in options">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <template v-if="isOperate">
          <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['upkeep:script:add']">
            <a-icon type="plus" />新增
          </a-button>
          <a-button
            type="primary"
            :disabled="single"
            @click="$refs.createForm.handleUpdate(undefined, ids)"
            v-hasPermi="['upkeep:script:edit']"
          >
            <a-icon type="edit" />修改
          </a-button>
          <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['upkeep:script:remove']">
            <a-icon type="delete" />删除
          </a-button>
        </template>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :userList="userList"
        :statusOptions="dict.type['sys_enable_disable']"
        @ok="getList"
      />
      <!-- 批量导入 -->
      <UploadAdd ref="uploadAdd" @ok="getList"></UploadAdd>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="status" slot-scope="text, record">
          <template>
            <a-popconfirm ok-text="是" cancel-text="否" @confirm="handleStatusType(record)">
              <span
slot="title"
                >确认<b>{{ record.status === 0 ? '启用' : '停用' }}</b> {{ record.title }}的类型吗?
              </span>
              <a-switch checked-children="启用" un-checked-children="停用" :checked="record.status === 1" />
            </a-popconfirm>
          </template>
          <!-- <template v-else>
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status" />
          </template> -->
        </span>
        <span slot="scriptExplanation" slot-scope="text, record">
          <!-- <a  > 查看 </a> -->
          <!-- <a-tooltip :title="record.scriptExplanation" title-type="html">
            <a> 查看 </a>
          </a-tooltip> -->
          <a-tooltip>
            <template #title>
              <div v-html="record.scriptExplanation"></div>
              <!-- 富文本支持 -->
            </template>
            <a> 查看 </a>
          </a-tooltip>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['upkeep:script:edit']"> 修改 </a>
          <a-divider type="vertical" v-hasPermi="['upkeep:script:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['upkeep:script:remove']"> 删除 </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchList, delObj, statusObj } from '@/api/repairModule/repairOrder'
import CreateForm from './modules/CreateForm'

import { tableMixin } from '@/store/table-mixin'
import { listTenant } from '@/api/system/tenant'
// import UploadAdd from './modules/uploadAdd'
// import Parameter from '../../pressure/parameter'
import UploadAdd from '../../system/tenant/modules/uploadAdd.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Post',
  components: {
    CreateForm,
    UploadAdd,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
    tenantFirmId: {
      type: [String, Number],
    },
    tenantId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      list: [],
      userList: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        keyword: undefined,
        periodType: undefined,
        searchCount: undefined,
      },
      options: [
        { name: '已下单', id: 1 },
        { name: '待接单', id: 10 },
        { name: '派单中', id: 11 },
        { name: '转单中', id: 12 },
        { name: '等待上门', id: 20 },
        { name: '挂起工单', id: 21 },
        { name: '已上门', id: 22 },
        { name: '报价中', id: 23 },
        { name: '维修中', id: 24 },
        { name: '待付款', id: 30 },
        { name: '已完成', id: 40 },
        { name: '订单已取消', id: 50 },
        { name: '已合并订单', id: 51 },
      ],
      columns: [
        {
          title: '订单号',
          dataIndex: 'orderNo',
          align: 'center',
        },
        {
          title: '客户姓名	',
          dataIndex: 'receiverName',
          align: 'center',
        },
        {
          title: '客户电话		',
          dataIndex: 'receiverMobile',
          align: 'center',
        },
        {
          title: '预约时间		',
          dataIndex: 'receiverUpTime',
          align: 'center',
        },
        {
          title: '客户地址		',
          dataIndex: 'receiverDetailedAddress',
          align: 'center',
        },
        {
          title: '优惠总额			',
          dataIndex: 'reduceAmount',
          align: 'center',
        },
        {
          title: '优惠金额			',
          dataIndex: 'platformAmount',
          align: 'center',
        },
        {
          title: '优惠金额			',
          dataIndex: 'platformAmount',
          align: 'center',
        },
        {
          title: '优惠金额			',
          dataIndex: 'platformAmount',
          align: 'center',
        },
        {
          title: '实际总值				',
          dataIndex: 'actualTotal',
          align: 'center',
        },
        {
          title: '上门类型				',
          dataIndex: 'isUpDoor',
          align: 'center',
        },
        {
          title: '订单标签					',
          dataIndex: 'label',
          align: 'center',
        },
        {
          title: '订单来源					',
          dataIndex: 'orderSource',
          align: 'center',
        },
        {
          title: '订单类型					',
          dataIndex: 'orderType',
          align: 'center',
        },
        {
          title: '上门时间						',
          dataIndex: 'upDoorTime',
          align: 'center',
        },
        {
          title: '上门时间						',
          dataIndex: 'upDoorTime',
          align: 'center',
        },
        {
          title: '用户确认状态						',
          dataIndex: 'userConfirm',
          align: 'center',
        },
        {
          title: '用户确认时间						',
          dataIndex: 'userConfirmTime',
          align: 'center',
        },
        {
          title: '完成时间							',
          dataIndex: 'finallyTime',
          align: 'center',
        },
        {
          title: '完成时间							',
          dataIndex: 'finallyTime',
          align: 'center',
        },
        {
          title: '派单时间',
          dataIndex: 'groupTime',
          align: 'center',
        },
        {
          title: '接单时间',
          dataIndex: 'connectTime	',
          align: 'center',
        },
        {
          title: '状态	',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime	',
          align: 'center',
        },
        // {
        //   title: '话术说明	',
        //   dataIndex: 'scriptExplanation',
        //   scopedSlots: { customRender: 'scriptExplanation' },
        //   ellipsis: true,
        //   align: 'center',
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    if (!this.isOperate) {
      this.columns.pop()
    }
    this.queryParam.tenantFirmId = this.tenantFirmId
    this.queryParam.tenantId = this.tenantId
    this.getList()
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {
    // type
    // 点击批量添加设备
    handleUpload() {
      this.uploadAdd = true
      this.$nextTick(() => {
        this.$refs.uploadAdd.init(3)
      })
    },
    // 状态修改
    handleStatusType(row) {
      // row.status = row.status == '0' ? '1' : '0'
      statusObj({ id: row.id })
        .then(() => {
          this.$message.success('操作成功！')
          this.getList()
        })
        .catch(function () {
          row.status = row.status == '0' ? '1' : '0'
        })
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    /** 查询部门列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    // 点击确定
    onChange(e) {
      console.log(e, '的点点滴滴')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'fix/dev/export',
            {
              ...that.queryParam,
            },
            `设备信息${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
